<template>
  <validation-provider :rules="validations" v-slot="{ errors }">
    <v-text-field
      :value="value"
      :label="field.label"
      outlined
      type="time"
      required
      @input="onChange"
      :error-messages="errors"
      color="#005c7b"
    >
    </v-text-field>
  </validation-provider>
</template>

<script>
export default {
  props: ["field", "value", "validations"],
  methods: {
    onChange: function (event) {
      if (event) {
        this.$emit("fieldChange", event);
        return;
      } else {
        var date = new Date();
        var time = event.split(":");
        if (time.length == 2) {
          var h = time[0];
          var m = time[1];
          date.setHours(h);
          date.setMinutes(m);
          this.$emit("fieldChange", date);
        } else {
          this.$emit("fieldChange", null);
        }
      }
    }
  }
};
</script>